<div class="form-check form-switch form-check-reverse">
  <input
    #toggle
    class="form-check-input"
    type="checkbox"
    role="switch"
    [id]="formConfig.id"
    [attr.name]="formConfig.name"
    [attr.aria-label]="formConfig.ariaLabel"
    [attr.ngbautofocus]="formConfig.autoFocus ? '' : undefined"
    (change)="onChange(toggle.checked)"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnter(toggle.checked)" />
  @if (formConfig.label) {
    <label class="form-check-label" [for]="formConfig.id">{{ formConfig.label }}</label>
  }
</div>
@if (displayErrorMessage()) {
  <div class="form-text">{{ errorMessage }}</div>
}
